import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import "./Button.scss";

const buttonStyles = {
	blue: "blue_button",
	black: "black_button",
	white: "white_button",
	outlineWhite: "outline_white",
	outlineBlack: "outline_black",
	purpleGradient: "purple_gradient_button",
};

const buttonSizes = {
	xsmall: "xsmall_button",
	small: "small_button",
	large: "large_button",
	fill: "fill_button",
};

const Button = ({
	link,
	styleName = "blue_button",
	size = "large",
	children,
}) => {
	const styleClass = buttonStyles[styleName] || buttonStyles.blue;
	const sizeClass = buttonSizes[size] || buttonSizes.large;

	return (
		<Link to={link} className={`button ${styleClass} ${sizeClass}`}>
			{children}
		</Link>
	);
};

// Prop Types for better validation
Button.propTypes = {
	link: PropTypes.string.isRequired,
	styleName: PropTypes.oneOf([
		"blue",
		"white",
		"outlineWhite",
		"outlineBlack",
	]),
	size: PropTypes.oneOf(["small", "large", "fill"]),
	children: PropTypes.node.isRequired,
};

export default Button;
